import React from "react";
import { PRO_PLANS } from "@/lib/pricing";
import { cn } from "@/lib/utils";

const PlanCard = ({ plan, selected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(plan.key)}
    className={cn(
      "relative w-full text-left rounded-[12px] p-7 border transition-all duration-200 ease-smooth",
      selected
        ? "bg-bg-secondary border-accent-pink shadow-pink-glow-lg"
        : "bg-bg-primary border-border-default hover:border-accent-pink/60"
    )}
    data-testid={`pro-plan-card-${plan.key}`}
    aria-pressed={selected}
  >
    {plan.badge && (
      <span className="absolute top-3 right-3 bg-accent-pink text-[#091424] font-bold text-[10px] tracking-wider px-2 py-1 rounded">
        {plan.badge}
      </span>
    )}
    <div className="text-accent-pink font-bold text-[11px] tracking-[0.1em]">{plan.label}</div>
    <div className="text-white font-extrabold text-[24px] mt-1">{plan.duration.split(" / ")[0]}</div>
    <div className="text-text-secondary text-[13px] mt-1">
      {plan.duration.split(" / ")[1] ? `per ${plan.duration.split(" / ")[1]}` : ""}
    </div>
    {plan.strike && (
      <div className="mt-3 text-[13px] text-text-muted line-through jea-mono" data-testid={`pro-strike-${plan.key}`}>
        ${plan.strike.toLocaleString()}
      </div>
    )}
    <div className="text-accent-pink font-extrabold text-[32px] jea-mono mt-1">
      ${plan.price.toLocaleString()}
    </div>
    <p className="text-text-secondary text-[13px] mt-3 leading-5">{plan.subtext}</p>
  </button>
);

const PlanProStep = ({ data, patchSection }) => {
  const cadence = data.plan?.cadence || null;

  return (
    <div className="space-y-6" data-testid="plan-pro-step">
      <div className="space-y-2">
        <h2 className="text-white font-bold text-[22px]">Choose Your Plan</h2>
        <p className="text-text-secondary text-[15px]">
          PRO includes unlimited judgments, advanced dashboard mode, and preferred per-query broker
          pricing. Per-query broker costs still apply.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4" data-testid="pro-plan-cards">
        {PRO_PLANS.map((p) => (
          <PlanCard
            key={p.key}
            plan={p}
            selected={cadence === p.key}
            onSelect={(k) => patchSection("plan", { cadence: k })}
          />
        ))}
      </div>
    </div>
  );
};

export default PlanProStep;
